/* eslint-disable */
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import EntriesContextPropTypes from '../../Contexts/Entries/Entries.props';
import authActionCreators from '../../State/Store/Auth/Auth.actions';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import propsActionCreatorsToPropTypes from '../../Support/Props/ActionCreatorKey/PropsActionCreatorsToPropTypes.support';

const LoginPagePropTypes = {
  /**
   * The actions to be used by this component
   */
  actions: PropTypes.shape({
    ...propsActionCreatorsToPropTypes(authActionCreators),
  }).isRequired,

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The current `entry`
   */
  entry: EntriesContextPropTypes.entry.isRequired,

  /**
   * The `history` props from `react-router`
   */
  history: ReactRouterPropTypes.history.isRequired,

  /**
   * The `location` props from `react-router`
   */
  location: ReactRouterPropTypes.location.isRequired,

  /**
   * The `match` props from `react-router`
   */
  match: ReactRouterPropTypes.match.isRequired,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default LoginPagePropTypes;
